<template>
  <div class="empty-coltrol">
    <img :src="image" />
    <span>{{ context }}</span>
    <van-button
      color="#0F6EEA"
      text="去首页逛逛"
      class="submitBtn f16 cfff fw600 mt30"
      @click.stop="$router.push(LinkTypeCode.Home)"
      v-if="homeButton"
    />
    <div class="new-goods-collect-text" v-if="showNewGoodsCollect">
      <p class="collect-title">
        没找到想要的商品？
      </p>
      <div class="info">
        没有找到相关的宝贝请提交您想要的商品，<br />
        如平台上架商品后，将第一时间通知您。
      </div>
      <van-button class="toNewGoodsCollect" @click.stop="toNewGoodsCollectPage">去提交</van-button>
    </div>
  </div>
</template>
<script>
import { LinkTypeCode } from '@/dictionary/base.js'

let list = [
  'cart',
  'goods',
  'network',
  'order',
  'message',
  'coupon',
  'feedback',
]
export default {
  name: 'EmptyControl',
  data() {
    return {
      LinkTypeCode,
      image: require('@/assets/empty/cart.png'),
      context: '',
      list: list,
    }
  },
  props: {
    type: {
      type: String,
      default() {
        return 'cart'
      },
      validator(value) {
        return list.indexOf(value) > -1
      },
    },
    text: {
      type: String,
      default() {
        return ''
      },
    },
    homeButton: {
      type: Boolean,
      default: false,
    },
    showNewGoodsCollect: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.image = require('@/assets/empty/' + this.type + '.png')
    this.context = this.text
  },
  methods:{
    toNewGoodsCollectPage() {
      const toUrl = this.$router.resolve('/NewGoodsCollect')
      window.open(toUrl.href, '_blank')
    },
  }
}
</script>
<style lang="less">
.empty-coltrol {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  width: 100%;

  img {
    width: 260px;
    height: 260px;
  }

  span {
    color: #777777;
    font-size: 12px;
    margin-top: 15px;
  }

  .submitBtn {
    width: 164px;
    height: 50px;
    background: rgba(15, 110, 234, 1);
    border-radius: 2px;

    span {
      margin: 0;
      color: #fff;
      font-size: 16px;
    }
  }

  // 无数据时新品收集提示
  .new-goods-collect-text {
    text-align: center;
    color: #111a34;
    font-size: 14px;
    .collect-title {
      margin: 0 auto 12px;
      font-size: 16px;
    }
    .info {
      margin-bottom: 24px;
      color: #41485D;
      font-size: 14px;
    }
    .toNewGoodsCollect {
      width: 160px;
      height: 40px;
      background: #0f6eea;
      border-radius: 4px;
      line-height: 40px;
      span{
        color: #ffffff;
        font-size:16px;
        margin: 0;
      }
   
    }
  }
}
</style>
